// extracted by mini-css-extract-plugin
module.exports =  {"clickableCard":"jut__ClickableCard__clickableCard","disabled":"jut__ClickableCard__disabled","activeKeypress":"jut__ClickableCard__activeKeypress"};